import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    M: {
        id: 'phoneGenderType.MALE',
        defaultMessage: 'Male',
    },
    F: {
        id: 'phoneGenderType.FEMALE',
        defaultMessage: 'Female',
    },
    PREFER_NOT_TO_SAY: {
        id: 'phoneGenderType.preferNotToSay',
        defaultMessage: 'Prefer not to say',
    },
});

export default enumMessages;
